// 案件詳細での「同意書を表示する」ボタン
import React from 'react';
import CenterButton from '../atoms/CenterButton';
import Heading from './Heading';

interface Props {
  heading_disabled?: boolean;
  reception_id: number;
}

const ShowAgreementButton: React.FC<Props> = ({ heading_disabled, reception_id }) => {
  // 同意書確認画面に遷移
  const handleClick = () =>
    location.replace(
      `${location.origin}${process.env.MIX_MOCK_URL}/confirm_consent?r_id=${reception_id}`
    );

  return (
    <div className="mt-5">
      {!heading_disabled && <Heading label="同意書" size="s" />}
      <CenterButton
        label="同意書を表示する"
        btn_class="btn-base arrow-right"
        handleClick={handleClick}
      />
    </div>
  );
};

export default ShowAgreementButton;
